import { HistoryOrder } from '@api-product/models';
import {
  ProfileHistoryTableData,
  TableColumns,
  TablePurchasesRows,
  TableWithdrawRows,
} from '@widgets/desktop/profile-history/ui/profile-history.types';
import { nanoid } from 'nanoid';

export const tablePurchasesCols: TableColumns = {
  paymentMethodId: {
    title: 'Method',
  },
  id: {
    title: 'ID',
  },
  totalAmount: {
    title: 'Total',
  },
  status: {
    title: 'Status',
  },
  createdAt: {
    title: 'Date',
  },
  link: {
    title: '',
  },
};

export const tableWithdrawCols: TableColumns = {
  id: {
    title: 'ID',
  },

  nickname: {
    title: 'Name',
  },
  status: {
    title: 'Status',
  },
  item: {
    title: 'Item',
  },
  properties: {
    title: 'Properties',
  },
  price: {
    title: 'Price',
  },
  date: {
    title: 'Date',
  },
};

export const tableActiveOrdersCols = tablePurchasesCols;

export const tablePurchasesRows: HistoryOrder[] =
  generateLargeDataset('purchases');

export const tableActiveOrdersRows: HistoryOrder[] =
  generateLargeDataset('active-orders');

export const tableWithdrawRows: TableWithdrawRows[] = [
  {
    item: {
      imageUri:
        'https://starpets.ams3.cdn.digitaloceanspaces.com/AM/royal_egg_218155608038015716861250016536746955046.png',
      rare: 'legendary',
      game: 'mm2',
      name: 'Royal Egg',
      age: 'full_grown',
      type: 'knife',
    },
    properties: {
      flyable: null,
      rideable: null,
      pumping: 'neon',
    },
    id: '27271',
    price: 3.22,
    status: 'Ready for withdraw',
    date: '04.03.24',
    nickname: 'Aladin',
  },
];

export function formatDateToDDMMYYYY(dateString: string): string {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // месяцы с 0
  const year = date.getFullYear();

  return `${day}.${month}.${year}`;
}

function getRandomDate(offsetDays: number = 0): string {
  const date = new Date();
  date.setDate(date.getDate() + offsetDays);
  return date.toISOString();
}

function getRandomStatus(
  filterBy?: 'active-orders' | 'purchases',
): HistoryOrder['status'] {
  const allStatuses: HistoryOrder['status'][] = [
    'PLACED',
    'PENDING',
    'PAID',
    'COMPLETED',
    'FAILED',
  ];

  const purchasesStatuses: HistoryOrder['status'][] = ['COMPLETED', 'FAILED'];
  const activeOrdersStatuses: HistoryOrder['status'][] = [
    'PLACED',
    'PENDING',
    'PAID',
  ];

  if (filterBy === 'active-orders') {
    return activeOrdersStatuses[
      Math.floor(Math.random() * activeOrdersStatuses.length)
    ];
  }

  if (filterBy === 'purchases') {
    return purchasesStatuses[
      Math.floor(Math.random() * purchasesStatuses.length)
    ];
  }

  return allStatuses[Math.floor(Math.random() * allStatuses.length)];
}

function getRandomPaymentMethodId() {
  const methodsIds = [
    '01968511-e059-711f-b5d7-9c4619927c6c',
    '01968511-e079-7362-8b22-045087c0b136',
    '01968511-e093-71a9-9c6b-5a0971503ea4',
    '01968511-e0ae-7608-aec5-77bf6035af12',
    '01968511-e0c9-758f-bbb0-2ce4180ed376',
    '01968511-e0e3-73ea-888b-00d9e9712441',
    '01968511-e0fd-74db-9d3b-a15a6bb88e1f',
    '01968511-e118-7548-aab2-ff329bca6c80',
    '01968511-e132-7674-a997-1411b8cb2ceb',
    '01968511-e14c-70fa-a158-c77b54b95363',
    '01968511-e166-758e-ab21-789d25f0cc4c',
    '01968511-e180-765b-a1c6-6deff5998e98',
    '01968511-e19a-7010-bfb0-42ebf1a367e3',
    '01968511-e1b3-743f-b4a9-f7c118d46737',
    '01968511-e1cd-757a-a89a-522db1751706',
  ];

  return methodsIds[Math.floor(Math.random() * methodsIds.length)];
}

function generateLargeDataset(
  filterBy?: 'active-orders' | 'purchases',
): TablePurchasesRows[] {
  const items: TablePurchasesRows[] = [];

  for (let i = 0; i < 100_000; i++) {
    const amount = (Math.random() * 100).toFixed(2);
    const discount = (Math.random() * 10).toFixed(2);
    const promoDiscount = (Math.random() * 5).toFixed(2);
    const totalAmount = (
      parseFloat(amount) -
      parseFloat(discount) -
      parseFloat(promoDiscount)
    ).toFixed(2);
    const status = getRandomStatus(filterBy);

    items.push({
      id: nanoid(),
      amount,
      discount,
      promoDiscount,
      totalAmount,
      promoCodeId: Math.random() > 0.7 ? nanoid() : null,
      paymentMethodId: getRandomPaymentMethodId(),
      useBalance: Math.random() > 0.5,
      failReason: status === 'FAILED' ? 'EXPIRED' : null,
      status,
      expiryDate: getRandomDate(1),
      processedAt: Math.random() > 0.5 ? getRandomDate(2) : null,
      paidAt:
        status === 'PAID' || status === 'COMPLETED' ? getRandomDate(1) : null,
      createdAt: getRandomDate(-1),
      updatedAt: getRandomDate(0),
    });
  }

  return items;
}

export const testData: ProfileHistoryTableData = {
  'active-orders': {
    columns: tableActiveOrdersCols,
    rows: tableActiveOrdersRows,
  },

  withdraw: {
    columns: tableWithdrawCols,
    rows: tableWithdrawRows,
  },

  purchases: {
    columns: tablePurchasesCols,
    rows: tablePurchasesRows,
  },
};
